import { CheckCircle } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import { useLocation } from "react-router";
import { HeaderBackButtonHome } from "../components/HeaderBackButton";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";

let today = new Date();
const dd = String(today.getDate()).padStart(2, "0");
const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
const yyyy = today.getFullYear();
const time = today.getHours() + ":" + today.getMinutes();

export default function Success() {
  let { state } = useLocation();

  let { transaction_type, recipient, amount, pending, cointitle, coin } = state;

  const isCredit = transaction_type === "Credit";

  return (
    <>
      <HeaderBackButtonHome title={`Sent ${cointitle}`} />
      <Container maxWidth="sm">
        <Stack spacing={4}>
          <Box display={"flex"} justifyContent={"center"}>
            <Stack spacing={1} alignItems={"center"}>
              <Typography level="title-lg" color="primary">
                + <CryptoCurrencyFormat amount={coin} suffix={""} /> {cointitle}
              </Typography>
              <Typography level="body-sm">
                <CurrencyFormat amount={amount} prefix={"$"} seperator={true} />
              </Typography>
              <Stack spacing={1} direction={"row"}>
                <Typography level="body-sm">Completed</Typography>
                <Avatar variant="outlined" size="xsm">
                  <CheckCircle fontSize="small" color="success" />
                </Avatar>
              </Stack>
            </Stack>
          </Box>

          <List variant="outlined" sx={{ borderRadius: 10 }}>
            <ListItem>
              <ListItemContent>Status</ListItemContent>
              <Typography
                level="body-sm"
                color={pending ? "warning" : "success"}
              >
                {pending ? "Pending" : "Completed"}
              </Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Date</ListItemContent>
              <Typography level="title-sm">{`${mm}/${dd}/${yyyy} ${time}`}</Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Recipient</ListItemContent>
              <Typography
                level="title-sm"
                textAlign={"right"}
                noWrap={true}
                width={"50%"}
              >
                {recipient}
              </Typography>
            </ListItem>
          </List>
        </Stack>
      </Container>
    </>
  );
}
